import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import * as i1 from 'ngx-toastr';
import { ToastrModule } from 'ngx-toastr';
import * as i2 from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';

class ToastService {
    constructor(toastrService, translateService) {
        this.toastrService = toastrService;
        this.translateService = translateService;
    }
    showError(toast) {
        this.toastrService.error(this.translateService.instant(toast.message, toast.parameters), this.translateService.instant(toast.title));
    }
    showInfo(toast) {
        this.toastrService.info(this.translateService.instant(toast.message, toast.parameters), this.translateService.instant(toast.title));
    }
    showSuccess(toast) {
        this.toastrService.success(this.translateService.instant(toast.message, toast.parameters), this.translateService.instant(toast.title));
    }
    showWarning(toast) {
        this.toastrService.warning(this.translateService.instant(toast.message, toast.parameters), this.translateService.instant(toast.title));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: ToastService, deps: [{ token: i1.ToastrService }, { token: i2.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: ToastService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: ToastService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.ToastrService }, { type: i2.TranslateService }] });

class Toast {
    constructor(title, message, parameters) {
        this.title = title;
        this.message = message;
        this.parameters = parameters;
    }
}

class ToastModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: ToastModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.3", ngImport: i0, type: ToastModule, imports: [CommonModule,
            BrowserAnimationsModule, i1.ToastrModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: ToastModule, imports: [CommonModule,
            BrowserAnimationsModule,
            ToastrModule.forRoot({
                timeOut: 3000,
                positionClass: 'toast-bottom-right',
                preventDuplicates: true,
                countDuplicates: true,
                maxOpened: 5
            })] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.3", ngImport: i0, type: ToastModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        CommonModule,
                        BrowserAnimationsModule,
                        ToastrModule.forRoot({
                            timeOut: 3000,
                            positionClass: 'toast-bottom-right',
                            preventDuplicates: true,
                            countDuplicates: true,
                            maxOpened: 5
                        })
                    ],
                    exports: []
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { Toast as DpToast, ToastModule as DpToastModule, ToastService as DpToastService };
